var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('budget-group-details'),_vm._v(" "),(_vm.budget.name && _vm.budget.name !== 'Monthly')?_c('div',[_c('budget-group-campaign-list')],1):_vm._e()],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa416830","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/clients/BudgetGroupDetailsView.vue
// module id = iww/
// module chunks = 0